import { render, staticRenderFns } from "./biglower.vue?vue&type=template&id=c6d8ea04&scoped=true&"
import script from "./biglower.vue?vue&type=script&lang=js&"
export * from "./biglower.vue?vue&type=script&lang=js&"
import style0 from "./biglower.vue?vue&type=style&index=0&id=c6d8ea04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d8ea04",
  null
  
)

export default component.exports